<template>
    <span class="mx-2">
        <v-tooltip right content-class="white--tooltip" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
                <v-icon dense :color="tooltip.color ? tooltip.color : 'info'" :size="tooltip.size ? tooltip.size : undefined" v-bind="attrs" v-on="on">$info_s</v-icon> 
            </template>
            <span>
                <span v-if="tooltip.title"><b>{{ $t(tooltip.title) }}</b><br></span>
                <span v-html="tooltip.description_no_trad ? tooltip.description : $t(tooltip.description)"></span>
            </span>
        </v-tooltip>
    </span>
</template>

<script>
export default {
    name: "infoTooltip",
    props: ["tooltip"],
    data() {
        return {}
    },
}
</script>

<style lang="scss">
</style>